"use strict";
var openMenu = false;
AOS.init();
var menu = document.querySelector("#btn-menu");
if (menu) {
	menu.addEventListener("click", () => {
		if (openMenu) {
			menu.className = "disabled";
			document.querySelector("#menu").className = "disabled";
		} else {
			menu.className = "";
			document.querySelector("#menu").className = "";
		}
		openMenu = !openMenu;
	});
}



resizePages();
header();
window.addEventListener('scroll',header);
window.addEventListener('resize',resizePages);

function resizePages() {
	$("main").css({ 'minHeight': ($(window).height() - $("header.main").height()) });
	$(".page").css({ 'minHeight': ($(window).height() - $("header.main").height()) + 10 });
	$(".image-top-team").css({ 'maxHeight': ($(window).height() * 0.9) });
}
function header() {
	var wScrollTop = $(window).scrollTop();
	if (wScrollTop > 40) {
		$("header.main.products").addClass("over");
	} else {
		$("header.main.products").removeClass("over");
	}
}

var mapDOM = document.getElementById('map-clients');
var markers = [];
if (mapDOM) {
	var map = new google.maps.Map(mapDOM, {
		zoom: 4,
		center: { lat: -11.8590247, lng: -58.4271273},
		zoomControl: false,
		mapTypeControl: false,
		scaleControl: false,
		streetViewControl: false,
		rotateControl: false,
		fullscreenControl: false
	});
	var locations = [
		{ client: 'A Caminho do céu', lat: -7.2497518, lng: -39.1425009, image: 'images/clients/acaminhodoceu.png' },
		{ client: 'Araxá', lat: -7.243810, lng: -35.937120, image: 'images/clients/araxa.png' },
		{ client: 'Bahia Pax', lat: -11.304950, lng: -41.854550, image: 'images/clients/bahiapax.png' },
		{ client: 'Divina Luz', lat: -15.335930, lng: -49.117230, image: 'images/clients/divinaluz.png' },
		{ client: 'Gravatá Previ', lat: -8.2074024, lng: -35.5717276, image: 'images/clients/gravata.png' },
		{ client: 'Jardins da Serra', lat: -9.0305173, lng: -59.904753, image: 'images/clients/jardins.png' },
		{ client: 'JS Visão', lat: -3.74817, lng: -38.5884098, image: 'images/clients/jcvisao.png' },
		{ client: 'Lázaro', lat: -7.6723838, lng: -36.8806427, image: 'images/clients/lazaro.png' },
		{ client: 'Memorial Parque das Flores', lat: -3.9527341, lng: -38.8841076, image: 'images/clients/memorialparqueflores.png' },
		//{ client: 'Memorial São José', lat: -3.2051023, lng: -44.9757132, image: 'images/clients/memorialparqueflores.png' },
		{ client: 'Plano Paz', lat: -3.7662695, lng: -38.5616855, image: 'images/clients/planopaz.png' },
		{ client: 'Vale da Saudade', lat: -12.6336966, lng: -39.142522, image: 'images/clients/valesaudade.png' },
		{ client: 'Jardim do Éden', lat: -3.958101, lng: -38.6023097, image: 'images/clients/jardimdoeden.png' },
		{ client: 'Memorial Fortaleza', lat: -3.7918883, lng: -38.5972361, image: 'images/clients/memorialfortaleza.png' },
		{ client: 'Preciosa', lat: -12.8961583, lng: -38.3267816, image: 'images/clients/preciosa.png' },
		{ client: 'Reino do céu', lat: -7.2021165, lng: -39.321514, image: 'images/clients/reinodoceu.png' },
		{ client: 'Cristo Rei', lat: -9.739910, lng: -36.666070, image: 'images/clients/cristorei.png' },
		{ client: 'Viva', lat: -5.2887198, lng: -36.7625703, image: 'images/clients/viva.png' },
		{ client: 'PIAF', lat: -10.911260, lng: -37.063479, image: 'images/clients/piaf.png' },
		{ client: 'Pax Brasil', lat: -14.305864, lng: -43.764547, image: 'images/clients/paxbrasil.png' },
		{ client: 'Divino', lat: -6.512020, lng: -36.350280, image: 'images/clients/divino.png' },
		{ client: 'Afeto', lat: -11.3817259, lng: -37.6606926, image: 'images/clients/afeto.png' },
		{ client: 'Apta', lat: -7.243810, lng: -35.937120, image: 'images/clients/apta.png' },
		{ client: 'Boa Fé', lat: -8.357430, lng: -36.687570, image: 'images/clients/boafe.png' },
		{ client: 'Esperança', lat: -3.8123835, lng: -38.5758342, image: 'images/clients/esperanca.png' },
		{ client: 'PAF', lat: -11.262626, lng: -37.436134, image: 'images/clients/paf.png' },
		{ client: 'PAMF', lat: -7.5325866, lng: -46.048965, image: 'images/clients/pamf.png' },
		{ client: 'Pax Central', lat: -20.447283, lng: -54.617136, image: 'images/clients/paxcentral.png' },
		{ client: 'Pax Vida', lat: -9.656556, lng: -35.735097, image: 'images/clients/paxvida.png' },
		{ client: 'Pax Universal', lat: -3.9527341, lng: -38.8841076, image: 'images/clients/paxuniversal.png' },
		{ client: 'Paz Universal', lat: -5.2965587, lng: -36.7651526, image: 'images/clients/pazuniversal.png' },
		{ client: 'Prover', lat: -7.2275766, lng: -39.349329, image: 'images/clients/prover.png' },
		{ client: 'Renascer', lat: -7.65077, lng: -39.7576423, image: 'images/clients/renascer.png' },
		{ client: 'Santa Terezinha', lat: -10.5788362, lng: -37.3422912, image: 'images/clients/santaterezinha.png' },
		{ client: 'São Miguel', lat: -10.917993, lng: -37.061343, image: 'images/clients/saomiguel.png' },
		{ client: 'São Sebastião', lat: -6.2810193, lng: -38.3126841, image: 'images/clients/saosebastiao.png' },
		{ client: 'SBC João Pessoa', lat: -7.124695, lng: -34.9516386, image: 'images/clients/sbc.png' },
		{ client: 'SBC Natal', lat: -5.8289089, lng: -35.2045539, image: 'images/clients/sbc.png' },
		{ client: 'SBC Matriz', lat: -3.790451, lng: -38.598789, image: 'images/clients/sbc.png' },
		{ client: 'SBC Mossoró', lat: -5.1898287, lng: -37.3488999, image: 'images/clients/sbc.png' },
		{ client: 'SBC Teresina', lat: -5.0804112, lng: -42.8116912, image: 'images/clients/sbc.png' },
		{ client: 'Seridó', lat: -6.4616832, lng: -37.3260538, image: 'images/clients/serido.png' },
		{ client: 'Total Vida', lat: -9.7498474, lng: -36.6633902, image: 'images/clients/totalvida.png' },
		{ client: 'Viana Previ', lat: -3.1297613, lng: -45.277029, image: 'images/clients/viana.png' },
		{ client: 'Vida - Crato', lat: -7.232153, lng: -39.4030947, image: 'images/clients/vida.png' },
		{ client: 'Vida - Juazeiro do Norte', lat: -7.212998, lng: -39.3189557, image: 'images/clients/vida.png' },
		{ client: 'Vida - Paraíba', lat: -7.1206459, lng: -34.9083083, image: 'images/clients/vida.png' },
		{ client: 'Vida - Campos Sales', lat: -7.0738785, lng: -40.376458, image: 'images/clients/vida.png' },
		{ client: 'Vida - Araripina', lat: -7.5758837, lng: -40.5023372, image: 'images/clients/vida.png' },
		{ client: 'Vida Plena', lat: -7.2129148, lng: -39.3190132, image: 'images/clients/vidaplena.png' }
	];
	var infowindow;
	markers = locations.map(function(location, i) {
		var marker = new google.maps.Marker({
			map: map,
			icon: {
				url: 'images/marker_green.svg',
				scaledSize: new google.maps.Size(20, 32),
				anchor: new google.maps.Point(0, 32),
				origin: new google.maps.Point(0, 0),
			},
			position: {lat: location.lat, lng: location.lng},
			animation: google.maps.Animation.DROP,
			title: location.client
		});
		marker.addListener('click', function() {
			if (infowindow) {
				infowindow.close();
			}
			var isOpera = (navigator.userAgent.match(/Opera|OPR\//) ? true : false);
			infowindow = new google.maps.InfoWindow({
				content: '<div class="'+(isOpera ? 'opera' : '')  +' box-info-map"><img src="'+location.image+'" height="50" width="50"/><h4 class="title-client-map">'+location.client+'</h4></div>'
			});
			infowindow.open(map, marker);
		});
		return marker;
	});
}

if (document.querySelector(".carousel-results")) {
	var slider = tns({
		"slideBy": "page",
		container: '.carousel-results',
		nav: false,
		controls: false,
		"items": 1,
		"autoplay": true,
		"mouseDrag": true,
		"autoplayTimeout": 5000,
		autoplayButtonOutput: false,
		"swipeAngle": false,
		"speed": 400
	});
}
/*
if (document.querySelector(".carousel-clients")) {
	var sliderClients = tns({
		container: '.carousel-clients',
		nav: false,
		navContainer: false,
		"slideBy": "page",
		controls: false,
		"items": 3,
		autoWidth: true,
		glutter: 10,
		"autoplay": true,
		"mouseDrag": true,
		"autoplayTimeout": 5000,
		autoplayButtonOutput: false,
		"swipeAngle": false,
		"speed": 400
	});
}*/
if (document.querySelector(".carousel-comments")) {
	var sliderComments = tns({
		container: '.carousel-comments',
		navContainer : ".dots-comments",
		"slideBy": "page",
		controls: false,
		"items": 3,
		autoWidth: true,
		glutter: 10,
		"autoplay": true,
		"mouseDrag": true,
		"autoplayTimeout": 5000,
		autoplayButtonOutput: false,
		"swipeAngle": false,
		"speed": 400
	});
}

$(".lbl-tp-contact").click(function () {
	$(".lbl-tp-contact").removeClass("active");
	$(this).addClass("active");
	$("#tp-contact").val($(this).data("value"));
});

$("#Inicio").bind("mouseover click", function () {
	$(".points").addClass("hidden");
	$(".point-1").removeClass("hidden");
});
$("#ponto2").bind("mouseover click", function () {
	$(".points").addClass("hidden");
	$(".point-2").removeClass("hidden");
});
$("#ponto3").bind("mouseover click", function () {
	$(".points").addClass("hidden");
	$(".point-3").removeClass("hidden");
});
$("#ponto4").bind("mouseover click", function () {
	$(".points").addClass("hidden");
	$(".point-4").removeClass("hidden");
});

$('a[href*="#"]').not('[href="#"]').not('[href="#0"]').click(function (event) {
	// On-page links
	if (
		location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
		&&
		location.hostname == this.hostname
	) {
		// Figure out element to scroll to
		var target = $(this.hash);
		target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
		// Does a scroll target exist?
		if (target.length) {
			// Only prevent default if animation is actually gonna happen
			event.preventDefault();

			openMenu = false;
			if (document.querySelector("#btn-menu")) {
				document.querySelector("#btn-menu").className = "disabled";
				document.querySelector("#menu").className = "disabled";
			}

			$('html, body').animate({
				scrollTop: target.offset().top - 120
			}, 1000, function () {
				// Callback after animation
				// Must change focus!
				var $target = $(target);
				$target.focus();
				if ($target.is(":focus")) { // Checking if the target was focused
					return false;
				} else {
					$target.attr('tabindex', '-1'); // Adding tabindex for elements not focusable
					$target.focus(); // Set focus again
				};
			});
		}
	}
});


$("#form-contact").submit(function () {
	var contact = $(this).serializeArray();
	$.ajax({
		method: "POST",
		url: "sendEmail.php",
		data: contact,
		dataType: "json",
		beforeSend: function () {
			$("#btn-send-contact").html('Carregando...').attr('disabled');
		},
		success: function (data) {
			console.log(data);
			if (data.code === 'OK') {
				alertify.alert('label changed!').set('label', 'OK'); 
				alertify.alert(
					'', 
					'<h2 style="text-align: center; color: #09345f"><span  style="color: green" class="iconify" data-height="50" data-icon="feather:check-circle" data-inline="false"></span><br>Mensagem enviada com sucesso.</h2>',
					function(){}
				);
				$("#btn-send-contact").html('<i class="icon"></i> Enviar').removeAttr('disabled');
				$(this).reset();
			} else if (data.message) {
				alertify.alert('label changed!').set('label', 'OK'); 
					alertify.alert(
						'', 
						'<h2 style="text-align: center; color: #09345f"><span  style="color: orange" class="iconify" data-height="50" data-icon="feather:alert-triangle" data-inline="false"></span><br>'+data.message+'</h2>',
						function(){}
					);
			} else {
				alertify.alert('label changed!').set('label', 'OK'); 
				alertify.alert(
					'', 
					'<h2 style="text-align: center; color: #09345f"><span  style="color: red" class="iconify" data-height="50" data-icon="feather:alert-circle" data-inline="false"></span><br>Houve um erro inesperado, tente novamete.</h2>',
					function(){}
				);
			}
			$("#btn-send-contact").html('<i class="icon"></i> Enviar').removeAttr('disabled');
		},
		error: function (error) {
			$("#btn-send-contact").html('<i class="icon"></i> Enviar').removeAttr('disabled');
			console.log("error", error);
			if (error.responseJSON) {
				if (error.responseJSON.message) {
					alertify.alert('label changed!').set('label', 'OK'); 
					alertify.alert(
						'', 
						'<h2 style="text-align: center; color: #09345f"><span  style="color: red" data-height="50" class="iconify" data-icon="feather:alert-circle" data-inline="false"></span><br>'+error.responseJSON.message+'</h2>',
						function(){}
					);
					return;
				}
			}
			alertify.alert('label changed!').set('label', 'OK'); 
			alertify.alert(
				'', 
				'<h2 style="text-align: center; color: #09345f"><span  style="color: red" data-height="50" class="iconify" data-icon="feather:alert-circle" data-inline="false"></span><br>Houve um erro inesperado, tente novamete.</h2>',
				function(){}
			);
		}
	});
});

///OCTADESK
(function (o, c, t, a, d, e, s, k) {
  o.octadesk = o.octadesk || {};
  s = c.getElementsByTagName("body")[0];
  k = c.createElement("script");
  k.async = 1;
  k.src = t + '/' + a + '?showButton=' +  d + '&openOnMessage=' + e;
  s.appendChild(k);
})(window, document, 'https://chat.octadesk.services/api/widget', 'pbr',  true, true);